import { arrayOf, bool, func, number, object, oneOf, oneOfType, string } from "prop-types";
import { Label } from "@components";
import classnames from "classnames";

export const LabelList = ({
  labels,
  idKey = "id",
  nameKey = "name",
  bgColorKey = "backgroundColor",
  fontColorKey = "fontColor",
  limit,
  className,
  spacing="small",
  ...labelProps
}) => (
  <>
    {
      labels
        .slice(0, limit)
        .map((t) => {
          const isString = typeof t === "string";
          return (
            <Label
              {...labelProps}
              key={isString ? t : t[idKey]}
              name={isString ? t : t[nameKey]}
              id={isString ? undefined : t[idKey]}
              backgroundColor={isString ? undefined : t[bgColorKey]}
              fontColor={isString ? undefined : t[fontColorKey]}
              className={classnames(
                spacing === "small" && "my-0-5 mx-0-5",
                spacing === "large" && "my-1 mx-1",
                className
              )}
            />
          );
        })
    }
  </>
);

LabelList.propTypes = {
  labels: arrayOf(oneOfType([string, object])).isRequired,
  onRemove: func,
  onClick: func,
  forceDot: bool,
  ellipsisOnOverflow: bool,
  useMaxWidth: bool,
  color: string,
  idKey: string,
  nameKey: string,
  bgColorKey: string,
  fontColorKey: string,
  limit: number,
  maxWidth: oneOfType([string, number]),
  spacing: oneOf(["small", "large"]),
  className: string,
};
